import * as React from 'react';
import { MtsTicketStore } from 'eTip--common';
import { observer } from 'mobx-react';
import { translationForMts } from 'easit--localization';
import { Instance } from 'mobx-state-tree';

export interface IDesktopTicketsWrapperProps {
    selectedTab: number;
    isCouponCopyVisible: boolean;
    tickets: Instance<typeof MtsTicketStore>,
    onTabChange: (value: number) => void;
    prepareCouponCopy: (params: { betType?: number; betId?: number; stake?: number }) => void;
    copyCoupon: () => void;
    clearCoupon: () => void;
    ticketContainer: React.ReactNode;
    isLive: boolean;
}

export const DesktopTicketsWrapper: React.FC<IDesktopTicketsWrapperProps> = observer((props: IDesktopTicketsWrapperProps) => {
    return (
        <div className="tickets-wrapper">
            <div className="ticket-tabs">
                {
                    props.tickets.tickets.map((_ticket, tabIndex) => {
                        if (tabIndex === props.tickets.tickets.length - 1) return null;

                        return <div
                            className={`ticket-tab  ${tabIndex === props.selectedTab ? 'selected' : ''}`}
                            key={tabIndex}
                            onClick={() => { props.onTabChange(tabIndex) }}
                        >
                            {tabIndex + 1}
                        </div>
                    })
                }
            </div>
            <div className="tab-header text-uppercase">
                {props.selectedTab + 1}. {translationForMts().ticket_BettingTicket}
                <span className="fa fa-trash" onClick={() => { props.clearCoupon() }}></span>
                {
                    props.isCouponCopyVisible &&
                    <span className="fa fa-copy ml-3" onClick={() => { props.copyCoupon() }}></span>
                }
            </div>
            {
                props.ticketContainer
            }
        </div>
    )
});